
// Import vendor modules.
import { Controller } from "@hotwired/stimulus";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

export class NavController extends Controller {

	static classes = [ "open" ];
	static targets = [ "menu" ];

	// ---
	// PUBLIC METHODS.
	// ---

	/**
	* I close the nav menu.
	*/
	close() {

		this.menuTarget.classList.remove( this.openClass );

	}


	/**
	* I open the nav menu.
	*/
	open() {

		this.menuTarget.classList.add( this.openClass );

	}


	/**
	* I toggle the nav menu visibility.
	*/
	toggleMenu( event ) {

		if ( this.isOpen() ) {

			this.close();

		} else {

			this.open();

		}

	}

	// ---
	// PRIVATE METHODS.
	// ---

	/**
	* I determine if the menu is currently toggled open.
	*/
	isOpen() {

		return( this.menuTarget.classList.contains( this.openClass ) );

	}

}
